import TierEntity from './TierEntity';

import Hobbit from "../../assets/Alpaka_Portrait/Hobit.jpeg";
import Kurt from "../../assets/Alpaka_Portrait/Kurt2.jpg";
import Anton from "../../assets/Alpaka_Portrait/Anton-6.jpg";
import Casper from "../../assets/Alpaka_Portrait/Casper.jpg";
import Jury from "../../assets/Alpaka_Portrait/Juri.jpg";
import Aton from "../../assets/Alpaka_Portrait/Aton-Bison.jpg"
import Nacho from "../../assets/Alpaka_Portrait/Nacho.jpg"
import Caleb from "../../assets/Alpaka_Portrait/Caleb.jpg"
import PlaceHolder from "../../assets/Alpaka_Portrait/placeHolder.png"
import Apollo from "../../assets/Alpaka_Portrait/Apollo.JPG"
import Nusspli from "../../assets/Alpaka_Portrait/Nusspli.JPG"


const hobbit = new TierEntity(
    "Hobbit",
    "Braun",
    "Ich bin der Stammesälteste und das 'Träumchenalpaka' für meine Menschen. Immer tiefenentspannt und gut gelaunt. Mein bester Freund Kurt und ich sind unzertrennlich. Ich glaube Kurt denkt, ich bin seine Mama. Ach, ich lasse mich auch streicheln, was bei meinen Menschen immer gut ankommt. Zusammen sind wir ein prima Paar.",
    Hobbit
);

const kurt = new TierEntity(
    "Kurt",
    "Beige",
    "Hallö hallö, ich bin der Kurt. Bin das jüngste Alpaka in unserer Männer-WG. Ich bin so gutmütig, dass man mich auch streicheln kann. Am liebsten von Menschen, die so klein sind wie ich. Mein Freund Hobbit und ich sind das Traumpaar schlechthin.",
    Kurt
);

const anton = new TierEntity(
    "Anton",
    "Braun",
    "Mein richtiger Name ist Shinning Unique, aber mein Personal meint, ich wäre so gesprächig gewesen als Cria (Fohlen), dass sie mich nur Tönchen gerufen haben. Und aus Tönchen wurde dann Anton. Mein Vlies ist so dick, dass mir mein Halfter immer wieder größer gemacht werden muss.",
    Anton
);

const caleb = new TierEntity(
    "Caleb",
    "Appaloosa (Weiß mit braunen Flecken)",
    "Anfangs wurde ich immer 'Cookie' genannt, da ich ein Appaloosa bin. Meine braunen Flecken sehen aus wie Schokotropfen in einem hellen Teig, wo wir schon beim Essen sind. Am Futtertrog bin ich der Chef und spiele gern den Futterwart, da muss man sich in Acht nehmen. Spucken kann ich nämlich besonders gezielt. Da kenne ich keine Freunde. Auch mein Bruder hat das schon zu spüren bekommen.",
    Caleb
);

const casper = new TierEntity(
    "Casper",
    "Appaloosa (Weiß mit braunen Flecken)",
    "Das bin ich. Ein Casper durch und durch. Der kleine Bruder von Calleb und unser Flaschenkind. Die ersten sechs Wochen meines Lebens waren für meine Personal seeehr anstrengend. Aber es hat sich gelohnt. Ich bin immer an der Seite meines Bruders zu finden. Wir sind unzertrennlich und durch unsere Tupfen auch leicht zu erkennen.",
    Casper
);

const nacho = new TierEntity(
    "Nacho",
    "Hellbraun",
    "Gudden alleseits! Ich bin der Schönste hier, denke ich! Mein Vlies ist so dicht und weich, dass man kaum die Finger davon lassen kann. Aber anfassen ist so gar nicht meins. Ok, am Hals meinetwenigen. Meine Kumpels mag ich alle und bin mit allen gut befreundet. Laufen mache ich sehr gerne, nur manchmal sticht mich der Halfter und ich muss mal springen.",
    Nacho
);

const aton = new TierEntity(
    "Aton",
    "Dunkelbraun",
    "Den Namen kenne ich kaum. Ich werde immer nur 'Bison' genannt. Hier gibt's Menschen, die behaupten, ich schaue aus wie diese Viecher. Ich bin ein absolut lustiges, wildes Alpaka. Immer in Bewegung und kaum zu bändigen. Mein bester Freund Jury und ich sind die schnellsten Flitzer, wenn wir wollen.",
    Aton
);

const jury = new TierEntity(
    "Jury",
    "Schwarz",
    "Ich bin Jury, der Araber unter den Alpakas. Tiefschwarz und sehr elegant, mache ich jedem Pferd Konkurrenz. Manchmal nerven mich die Kumpels, und ich muss zeigen, dass ich der Chef bin. Mein Bestie ist Aton. Wir laufen meist vorneweg, weil wir die Chefs sind.",
    Jury
);

const nusspli = new TierEntity(
    "Nusspli",
    "Weiß",
    "Hallöchen! Ich bin's. Ich bin der Herzensbrecher unter uns. Vielleicht weil ich der Größte bin? Aber das ist auch nicht schwer, bin ja ein Lama. Gerne schnuppere ich an den Gästen rum und bleibe bei den Menschen. Die haben oft etwas zum Fressen in der Hand. Die sagen dann, ich wäre ein sanfter Riese. Wie der Scheinriese aus der Augsburger Puppenkiste. Deswegen werde ich oft Herr Tur Tur genannt",
    Nusspli
);

const apollo = new TierEntity(
    "Appollo",
    "Geschekt",
    "Hallo ich bin's! Man sagt ich wäre ein kleines Appöllchen, weiß gar nicht warum? Am liebsten bin ich mit Nusspli unterwegs und fresse. Für jeden Spaß bin ich zu haben. Mein Personal sagt, ich bin das Ferkel der Herde, aber das ist mir egal.",
    Apollo
);

const TierListe = [
    jury,
    hobbit,
    kurt,
    caleb,
    anton,
    casper,
    aton,
    nacho,
    nusspli,
    apollo
];

export default TierListe;